/* Some functions */
Array.max = function( array ){
  return Math.max.apply( Math, array );
};
Array.min = function(array) {
  return Math.min.apply( Math, array );
};

theme.swapFitMeasurements = function(e) {
  const selectedMeasurement = e.target.getAttribute('data-fit-units');
  const formOptions = document.querySelectorAll('.find-my-size__form option');
  
  formOptions.forEach(option => {
    if(option.getAttribute('data-units') === selectedMeasurement) {
      option.style.display = 'block';
    } else { 
      option.style.display = 'none';
    }
  });    
};

theme.getSelectedValues = function(e) {
  const selects = document.querySelectorAll('#ff-select .select__select'),
        results = document.querySelector('#ff-results--wrapper'),
        options = document.querySelector('#ff-select--wrapper');
  let sizesToCheck = [],
      allSelected = true;
  
  selects.forEach((select) => {
    if(select.value === 'must-select') {
      select.classList.add('error');
      allSelected = false;
    } else {
      const myIndex = parseFloat(select.options[select.selectedIndex].getAttribute('data-index'));
      sizesToCheck.push(myIndex+1);
    }
  });
  if(!allSelected) return;
  theme.findMySize(sizesToCheck);
  options.style.display = 'none';
  results.style.display = 'block';
  
};

theme.findMySize = function(arr) {
  const sizes = ['XS','S','M','L','XL','XXL'];
  const min = Array.min(arr),
        max = Array.max(arr),
        mid = (max+min) / 2,
        midSize = Math.ceil(mid - 1);

  
  document.querySelector('.ff-result').textContent = sizes[midSize];
  theme.selectChosenSize(sizes[midSize]);
};

theme.selectChosenSize = function(size) {
  const sizeInput = document.querySelector(`.variant-radio input[name="Size"][value="${size}"]`);
  if(sizeInput) {
    sizeInput.checked = true;
  }
}

document.addEventListener('click',(e) => {
  
  const measurementSelectorIn = document.querySelector('.find-my-size__measurement-select[data-fit-units="inches"]');
  const measurementSelectorCm = document.querySelector('.find-my-size__measurement-select[data-fit-units="cm"]');
  const findMySizeReturn = document.querySelector('.find-my-size--return');
  const submit = document.querySelector('#ff-select .button');
  
  if(e.target == measurementSelectorIn) {
    measurementSelectorCm.classList.remove('active');
    e.target.classList.add('active');
    theme.swapFitMeasurements(e);
    e.preventDefault();
  }
  
  if(e.target == measurementSelectorCm) {
    
    measurementSelectorIn.classList.remove('active');
    e.target.classList.add('active');
    theme.swapFitMeasurements(e);
    e.preventDefault();
  }
  
  if(e.target == submit) {
    theme.getSelectedValues(e);
    e.preventDefault();
  }
  
  if(e.target == findMySizeReturn) {
    e.preventDefault();
    document.querySelector('#ff-results--wrapper').style.display = 'none';
    document.querySelector('#ff-select--wrapper').style.display = 'block';
  }
 
});

document.addEventListener('change',(e) => {
  if(e.target.classList.contains('select__select')) {
    e.target.classList.remove('error');
  }
})